import React, { useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useParams } from 'react-router-dom';
import { head, isEmpty, pathOr } from 'ramda';

// tools
import getNumberWithCurrency from '../../helpers/getNumberWithCurrency';

// store
import { storeSet, useStoreValue } from '../../store';

// components
import ProjectFeaturedImage from './components/ProjectFeaturedImage';
import ProjectInfo from './components/ProjectInfo';
import Button3d from '../../components/ButtonWrapper/components/Button3d';
import ButtonFlat from '../../components/ButtonWrapper/components/ButtonFlat';
import ButtonFlatAccent from '../../components/ButtonWrapper/components/ButtonFlatAccent';
import DateRangeBar from '../../components/DateRangeBar';
import NumericProgressBar from '../../components/NumericProgressBar';
import WidgetTeam from '../../components/WidgetTeam';
import CrossedEyeIcon from '../../icons/CrossedEyeIcon';
import WidgetEarningsTotal from './components/WidgetEarningsTotal';
import ModalAddCueSheetItem from '../../components/ModalAddCueSheetItem';
import ModalEditCueSheetItem from '../../components/ModalEditCueSheetItem';
import ButtonGroup from '../../components/ButtonGroup';
import ProjectCueSheet from './components/ProjectCueSheet';
import CommCenterProject from './components/CommCenterProject';
import useCacheProjectAudio from '../../hooks/useCacheProjectAudio';

const Project = () => {
    const projects = useStoreValue('projects');
    const cueSheetPanel = useStoreValue('cueSheetPanel');
    const { projectId } = useParams();
    const [data, setData] = useState({});
    const [isHidCompleted, setIsHidCompleted] = useState(false);
    const [selectedCueSheetItem, setSelectedCueSheetItem] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const handleCueSheetPanel = (type) => {
        storeSet('cueSheetPanel', type);
    }

    useEffect(() => {
        setSelectedCueSheetItem(null);
    }, [cueSheetPanel]);

    useEffect(() => {
        const project = pathOr({}, [], head(projects.filter(o => o.id === projectId)));
        setData(project);

        // Fetch project team via React Query action
        storeSet('fetchProjectTeam', projectId);
    }, [projectId, projects]);

    useCacheProjectAudio(projectId);

    return (
        !isEmpty(data)
            ? <>
                <div className="appDashboard">
                    <div className="appDashboard__workbench">
                        <div className="projectInfoWrapper">
                            <ProjectFeaturedImage url={data.thumbnailUrl} title={data.title}/>
                            <ProjectInfo data={data}/>
                        </div>
                        <div className="projectDataWrapper">
                            <div className="appWorkbenchPanel projectDataPanel">
                                <div>
                                    <ButtonGroup>
                                        <Button3d
                                            changeFn={() => handleCueSheetPanel('music')}
                                            name="music"
                                            checked={cueSheetPanel === 'music'}>
                                            {__('Cue Sheet', 'soundbetween')}
                                        </Button3d>
                                        <Button3d
                                            changeFn={() => handleCueSheetPanel('sfx')}
                                            name="sfx"
                                            checked={cueSheetPanel === 'sfx'}>
                                            {__('SFX', 'soundbetween')}
                                        </Button3d>
                                        <Button3d
                                            changeFn={() => handleCueSheetPanel('mix')}
                                            name="mix"
                                            checked={cueSheetPanel === 'mix'}>
                                            {__('Mix', 'soundbetween')}
                                        </Button3d>
                                    </ButtonGroup>
                                    {/*<Button3d
                                        changeFn={() => {
                                        }}
                                        name="chat"
                                        checked={false}>
                                        {__('Calendar', 'soundbetween')}
                                    </Button3d>*/}
                                </div>
                                <div>
                                    <Button3d
                                        changeFn={() => setIsHidCompleted(!isHidCompleted)}
                                        name="hideCompleted"
                                        checked={isHidCompleted}>
                                        <CrossedEyeIcon/>
                                    </Button3d>
                                    <span className="appFadedText">
                                        {__('Nascondi task completate', 'soundbetween')}
                                    </span>
                                    {selectedCueSheetItem
                                        ? <ButtonFlatAccent onClick={() => setIsEditModalOpen(true)}>
                                            {__('Modifica', 'soundbetween')}
                                        </ButtonFlatAccent>
                                        : <ButtonFlat disabled>
                                            {__('Modifica', 'soundbetween')}
                                        </ButtonFlat>
                                    }
                                    <ModalAddCueSheetItem projectId={projectId} type={cueSheetPanel}/>
                                </div>
                            </div>
                            <div className="projectsTasksWrapper">
                                <ProjectCueSheet
                                    projectId={projectId}
                                    type={cueSheetPanel}
                                    selectedItemId={selectedCueSheetItem?.id ?? null}
                                    onSelectItem={setSelectedCueSheetItem}
                                />
                            </div>
                        </div>
                    </div>
                    <CommCenterProject/>
                </div>
                <div className="appDashboard__widgets">
                    <WidgetEarningsTotal/>
                    <div className="appDashboard__widget">
                        {data && data.creationDate && data.deadline
                            ? <DateRangeBar
                                startDate={data.creationDate}
                                endDate={data.deadline}
                                title="Timeline"
                                description="{t1} giorni alla consegna"
                            /> : null}
                        {data
                            ? <NumericProgressBar
                            maxValue={data.budget}
                            targetValues={[0]}
                            title="Budget speso"
                            description={`{t1} € di ${getNumberWithCurrency(data.budget)}`}
                        /> : null}
                    </div>
                    <div className="appDashboard__widget">
                        <WidgetTeam projectId={projectId}/>
                    </div>
                </div>
                <ModalEditCueSheetItem
                    visible={isEditModalOpen && !!selectedCueSheetItem}
                    onHide={() => setIsEditModalOpen(false)}
                    projectId={projectId}
                    item={selectedCueSheetItem}
                />
            </> : null
    )
}

export default Project;